import { produce } from 'immer'

import { resolvePromptModelIdsHelper } from '@/reducers/prompts/prompts.helpers'

// Action Types
export const SET_LOADING = 'prompts/setLoading'
export const SET_ERROR = 'prompts/setError'
export const SET_PROMPTS = 'prompts/setPrompts'
export const SET_PRISTINE_PROMPTS = 'prompts/setPristinePrompts'
export const ADD_PROMPT = 'prompts/addPrompt'
export const EDIT_PROMPT = 'prompts/editPrompt'
export const SET_TEMPORARY_PROMPT = 'prompts/setTemporaryPrompt'
export const SET_MODEL_OPTIONS = 'prompts/setModelOptions'
export const SET_PERSONA_OPTIONS = 'prompts/setPersonaOptions'
// Action Creators
export const setLoading = (payload) => ({ type: SET_LOADING, payload })
export const setError = (payload) => ({ type: SET_ERROR, payload })
export const setPrompts = (payload) => ({ type: SET_PROMPTS, payload })
export const setPristinePrompts = (payload) => ({ type: SET_PRISTINE_PROMPTS, payload })
export const addPrompt = (payload) => ({ type: ADD_PROMPT, payload })
export const editPrompt = (payload) => ({ type: EDIT_PROMPT, payload })
export const setTemporaryPrompt = (payload) => ({ type: SET_TEMPORARY_PROMPT, payload })
export const setModelOptions = (payload) => ({ type: SET_MODEL_OPTIONS, payload })
export const setPersonaOptions = (payload) => ({ type: SET_PERSONA_OPTIONS, payload })
// State
export const initialState = {
  prompts: [],
  // The prompts exactly as the API last returned them, so a save can tell which ones a user actually changed.
  pristinePrompts: [],
  temporaryPrompt: null,
  modelOptions: {
    qa_copilot: [],
    copilot_fallback: [],
  },
  personaOptions: [],
  loading: {
    modelOptions: false,
    personaOptions: false,
    prompts: false,
    promptTests: false,
  },
  dirty: false,
  error: {
    prompt: false,
  },
}

// Reducer
export default function promptReducer(state = initialState, action) {
  return produce(state, (newState) => {
    const { payload } = action

    switch (action.type) {
      case SET_LOADING:
        newState.loading = { ...state.loading, ...payload }
        break
      case SET_ERROR:
        newState.error = { ...state.error, ...payload }
        break
      case SET_PROMPTS:
        newState.prompts = resolvePromptModelIdsHelper(payload, state.modelOptions)
        newState.dirty = false
        newState.error.prompt = false
        break
      case SET_PRISTINE_PROMPTS:
        // Resolved the same way as `prompts`, or a legacy prompt would read as edited and be versioned on save.
        newState.pristinePrompts = resolvePromptModelIdsHelper(payload, state.modelOptions)
        break
      case ADD_PROMPT:
        newState.prompts.push(payload)
        newState.dirty = true
        break
      case SET_TEMPORARY_PROMPT:
        newState.temporaryPrompt = payload
        newState.dirty = true
        break
      case SET_MODEL_OPTIONS: {
        // The options and the prompts are fetched side by side, so whichever lands second does the resolving.
        const modelOptions = { ...state.modelOptions, ...payload }

        newState.modelOptions = modelOptions
        newState.prompts = resolvePromptModelIdsHelper(state.prompts, modelOptions)
        newState.pristinePrompts = resolvePromptModelIdsHelper(state.pristinePrompts, modelOptions)
        break
      }
      case SET_PERSONA_OPTIONS:
        newState.personaOptions = payload
        break
      default:
        break
    }
  })
}
